import { RoutePaths } from '../../constants';

/** Роуты, для которых применяется светлая тема (белый цвет элементов) */
export const LIGHT_THEME_ROUTES = [RoutePaths.Prompt] as const;

export const isLightThemeRoute = (pathname: string) => {
    return LIGHT_THEME_ROUTES.some(route => {
        return pathname.startsWith(route);
    });
};
